const styles = theme => ({
  projectTab: {
    width: "100%",
    marginTop: 50,

    "& .MuiBox-root": {
      padding: 0
    },

    "& .MuiTab-wrapper": {
      fontSize: 14,
      fontWeight: "600",
      lineHeight: "30px"
    },
    "& .MuiTab-root": {
      padding: "10px 20px"
    },

    "& .MuiTouchRipple-root": {
      display: "none"
    }
  },
  tabBar: {
    display: "block",
    width: "100%"
  },
  tabItem: {
    position: "relative",
    zIndex: 1,
    minHeight: "auto",
    "& span": {
      flexDirection: "row",
      display: "flex",
      fontSize: 16,
      "& svg": {
        fontSize: 30,
        marginRight: 10
      }
    },
    "&:hover": {
      color: theme.colors.primary
    }
  },
  indicator: {
    height: "100%",
    background: 'none'
  },
  active: {
    color: "white!important",
    background: theme.colors.primary
  },
  title: {
    textAlign: "center",
    marginBottom: 30
  },
  viewMore: {
    padding: "10px 20px",
    border: `2px solid ${theme.colors.primary}`,
    display: "table",
    borderRadius: 3,
    color: theme.colors.primary,
    fontSize: 16,
    fontWeight: "600",
    margin: "auto",
    marginTop: 30,

    "&:hover": {
      color: "white",
      background: theme.colors.primary
    }
  },

  [theme.breakpoints.down('md')]: {
    tabBar: {
      margin: 'auto',
    },

    TabContents: {
      // width: "90vw",
      minHeight: "35px",
      "& root": {
        background: "black",
      },
      "& .MuiTab-wrapper": {
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "25px"
      },
      projectTab: {
        width: "100%",
        marginTop: 30,
        padding: "5px",
      }
    },
    projectTab: {
      "& .MuiTab-root": {
        padding: "5px 10px"
      }
    },
  },

  [theme.breakpoints.down('sm')]: {
    
  },

  [theme.breakpoints.down('xs')]: {
    tabBar: {
      // width: "90vw",
    },

    TabContents: {
      // width: "90vw",
      "& root": {
        backgroundColor: "black",
      },
    }
  },
});

export default styles;
